<template>
  <v-container>
    <v-row>
      <v-col>
        <TablePicker
          title="Data Table"
          v-model="value.table"
          :required="true"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <FieldValuePickerBase
          title="Row ID Value"
          v-model="value.idValue"
          type="text"
          :table="table"
          :component="component"
          :containers="containers"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ui from "../../../services/ui";

import TablePicker from "../shared/TablePicker.vue";
import FieldValuePickerBase from "../shared/FieldValuePickerBase.vue";

export default {
  name: "DeleteDataDesigner",

  components: { TablePicker, FieldValuePickerBase },

  props: ["value", "containers", "table", "component"],

  computed: {
    fields() {
      return ui.getRootFieldList(this.containers);
    },
  },
};
</script>
